import {
  Checkbox,
  Display1,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
} from '@sainsburys-tech/fable'
import React from 'react'

import { MixStageEnum } from '../../enums/MixStageEnum'
import { IMix } from '../../types/IMix'

interface IProps {
  mix: IMix
  allMixSkusMarked?: boolean
  handleCheckAll?: (checked: boolean) => void
  isNewAlgorithm: boolean
}

const MixSkusTableHeader = (props: IProps) => {
  const mix = props.mix
  if (
    props.mix !== null &&
    props.mix !== undefined &&
    props.mix.mixStatusStageId === (MixStageEnum.InProgress as number)
  ) {
    return (
      <TableHeader>
        <TableHeaderRow>
          <TableHeaderCell>
            {props.handleCheckAll && (
              <Checkbox
                isStandalone={true}
                label='Select all'
                value='select-all'
                isChecked={!!props.allMixSkusMarked}
                onChange={(checked) =>
                  props.handleCheckAll && props.handleCheckAll(checked)
                }
                testid='select-all-checkbox'
              />
            )}
          </TableHeaderCell>
          <TableHeaderCell data-testid='mix-type-inprogress'>
            <Display1>Type/SKU</Display1>
          </TableHeaderCell>
          <TableHeaderCell data-testid='mix-production-target-inprogress'>
            <Display1>Production target</Display1>
          </TableHeaderCell>
          <TableHeaderCell data-testid='mix-actual-production-inprogress'>
            <Display1>Actual production</Display1>
          </TableHeaderCell>
          {props.isNewAlgorithm && (
            <TableHeaderCell data-testid='mix-reason-inprogress'>
              <Display1>Reason</Display1>
            </TableHeaderCell>
          )}
        </TableHeaderRow>
      </TableHeader>
    )
  }

  if (
    props.mix !== null &&
    props.mix !== undefined &&
    props.mix.mixStatusStageId === (MixStageEnum.Completed as number)
  ) {
    return (
      <TableHeader>
        <TableHeaderRow>
          <TableHeaderCell data-testid='mix-type-completed'>
            Type/SKU
          </TableHeaderCell>
          <TableHeaderCell data-testid='mix-production-target-completed'>
            Production target
          </TableHeaderCell>
          <TableHeaderCell data-testid='mix-actual-production-completed'>
            Actual production
          </TableHeaderCell>
          {props.isNewAlgorithm && (
            <TableHeaderCell data-testid='mix-reason-completed'>
              <Display1>Reason</Display1>
            </TableHeaderCell>
          )}
        </TableHeaderRow>
      </TableHeader>
    )
  }

  if (mix !== undefined) {
    return (
      <TableHeader>
        <TableHeaderRow>
          <TableHeaderCell data-testid='mix-type-default'>
            Type/SKU
          </TableHeaderCell>
          <TableHeaderCell data-testid='mix-production-target-default'>
            Production target
          </TableHeaderCell>
        </TableHeaderRow>
      </TableHeader>
    )
  }

  return <div />
}

export default MixSkusTableHeader
